//src/services/adminAbandonedCarts.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminAbandonedCarts = () => {
  return adminApiRequest("/admin/abandoned-carts");
};

// ✅ NEW
export const sendAbandonedCartEmail = (userId) => {
  return adminApiRequest(`/admin/abandoned-carts/${userId}/send-email`, {
    method: "POST",
  });
};

